export const buttons = [
  {
    title: "Comunicativa",
    level: 1,
    position: 0,
    texto: `0 a 18 meses.
    Ainda no primeiro ano de vida do bebê, espera-se que a criança fale as suas primeiras palavras. A princípio, costumam ser palavras isoladas, como mamãe e papai. Além disso, o bebê já poderá emitir onomatopeias (au-au, miau, bibi). Com 1 ano e seis meses, é possível que o pequeno ou pequena comece a combinar duas palavras, como “da mamá” e “eu quero”, por exemplo para pedido de objeto ou ação. Deve-se também, ter atenção a sons, acompanhar objetos com o olhar, atender quando chamada pelo nome.`,
    id: 1,
    levels: [
      {
        title: "Sub-habilidade A",
        id: 1,
        levels: [
          { id: 1, level: 1 },
          { id: 2, level: 2 },
          { id: 3, level: 3 },
        ],
      },
      {
        title: "Sub-habilidade B",
        id: 2,
        levels: [
          { id: 1, level: 1 },
          { id: 2, level: 2 },
          { id: 3, level: 3 },
        ],
      },
    ],
  },
  {
    title: "Comunicativa",
    level: 2,
    position: 1,
    texto: ` 18 a 30 meses.
    Aos 2 anos de idade, costumam aparecer as primeiras frases de duas ou três palavras do bebê, como “eu quero papá”. Por volta de 2 anos e seis meses, começam as frases de três e quatro palavras. Criança compreende o não, usa brinquedos de forma funcional. Consegue nomear figuras ou identificar. Manifesta compreensão acerca da instrução do outro.
    `,
    id: 2,
    levels: [
      {
        title: "Sub-habilidade C",
        id: 3,
        levels: [
          { id: 1, level: 1 },
          { id: 2, level: 2 },
          { id: 3, level: 3 },
        ],
      },
      {
        title: "Sub-habilidade D",
        id: 4,
        levels: [
          { id: 1, level: 1 },
          { id: 2, level: 2 },
          { id: 3, level: 3 },
        ],
      },
    ],
  },
  {
    title: "Comunicativa",
    level: 3,
    position: 2,
    texto: `30 a 48 meses.
    Espera-se que, aos 3 anos, a criança já seja capaz de repetir trechos de histórias e produzir frases de quatro a cinco palavras para descrever situação ou objeto. Nessa idade é possível iniciar uma conversação, cantar músicas infantis e realizar narrativas sobre acontecimentos vivenciados pela criança. Já é capaz de nomear cores, letras do alfabeto e identificar seu próprio nome. 
    `,
    id: 3,
    levels: [
      {
        title: "Sub-habilidade E",
        id: 5,
        levels: [
          { id: 1, level: 1 },
          { id: 2, level: 2 },
          { id: 3, level: 3 },
        ],
      },
      {
        title: "Sub-habilidade F",
        id: 6,
        levels: [
          { id: 1, level: 1 },
          { id: 2, level: 2 },
          { id: 3, level: 3 },
        ],
      },
    ],
  },
  {
    title: "Social",
    level: 1,
    position: 0,
    texto: `0 a 18 meses.
    Nos primeiros meses de vida, é esperado que a o bebê olhe com intenção comunicativa e de interação. Também espera-se que ele emita sons e balbucios quando uma pessoa se aproxima com intuito de interação e que sorria em direção a uma pessoa. Indicar que deseja ser segurada levantando os braços é algo que também se espera nessa idade. Além disso a imitação motora e a exploração do ambiente são esperadas. Como recursos, a criança deve ser capaz de empilhar blocos, jogar simples jogos de encaixe e bincar com brinquedos de chacoalhar. Cócegas e músicas são habilidades sensório sociais que devem ser demonstrar reação da criança.`,
    id: 4,
    levels: [
      {
        title: "Sub-habilidade A",
        id: 1,
        levels: [
          { id: 1, level: 1 },
          { id: 2, level: 2 },
          { id: 3, level: 3 },
        ],
      },
      {
        title: "Sub-habilidade B",
        id: 2,
        levels: [
          { id: 1, level: 1 },
          { id: 2, level: 2 },
          { id: 3, level: 3 },
        ],
      },
    ],
  },
  {
    title: "Social",
    level: 2,
    position: 1,
    texto: `18 a 30 meses.
    Após os 18 meses, torna-se possível o início do brincar compartilhado, a habilidade de trocar de turno e o contato visual. Também espera-se que a criança possa aumentar o tempo de permanência em ambiente e em atividades sociais. Há o desenvolvimento de habilidades visuais e ja se espera a emissão de mando para iniciar a interação. Além disso, deve ser capaz de entregar brinquedos a outras crianças quando pedem e aceitar os brinquedos oferecidos. Como recursos se espera a realização de jogos de encaixe e quebra-cabeças simples. Começa-se a iniciar o brincar simbólico (faz de conta), com recursos como de comidinha e telefone. Montar brinquedos com múltiplas partes (como o Sr. Batata). Cócegas, bolinha de sabão, atividades com músicas e danças, pega-pega e esconde-esconde são habilidades sensório sociais que devem ser realizadas pela crianças.
    `,
    id: 5,
    levels: [
      {
        title: "Sub-habilidade C",
        id: 3,
        levels: [
          { id: 1, level: 1 },
          { id: 2, level: 2 },
          { id: 3, level: 3 },
        ],
      },
      {
        title: "Sub-habilidade D",
        id: 4,
        levels: [
          { id: 1, level: 1 },
          { id: 2, level: 2 },
          { id: 3, level: 3 },
        ],
      },
    ],
  },
  {
    title: "Social",
    level: 3,
    position: 2,
    texto: `30 a 48 meses.

    Aos 3 anos, espera-se que a criança seja capaz de interagir mutualmente com outras crianças e responder o outro. Também é esperado o brincar compartilhado e simbólico e a imitação motora. Como recursos esperados, tem-se o brincar de faz de conta, jogar bola e algumas brincadeiras compartilhadas, como jogo da memória e pega varetas.
    `,
    id: 6,
    levels: [
      {
        title: "Sub-habilidade E",
        id: 5,
        levels: [
          { id: 1, level: 1 },
          { id: 2, level: 2 },
          { id: 3, level: 3 },
        ],
      },
      {
        title: "Sub-habilidade F",
        id: 6,
        levels: [
          { id: 1, level: 1 },
          { id: 2, level: 2 },
          { id: 3, level: 3 },
        ],
      },
    ],
  },
  {
    title: "Motora",
    level: 1,
    position: 0,
    texto: `0 a 18 meses.
    Espera-se da criança de 0 a 18 meses, imitar 2 a 4 movimentos motores grossos quando solicitado (como bater palmas, levantar os braços. bater os pés, tocar o nariz), também imita movimentos com objetos quando solicitado (balançar um chocalho, empilhar 2 cubos, entre outros). Além disso, espera-se a imitação de forma espontânea o comportamento de outros (como mandar beijos, dar abraços, aperto de mão, entre outros). É esperada a capacidade de pintar com os dedos utilizando tinta e de utilizar os dedos em pinça para pegar objetos pequenos. Como atividades, espera-se que a criança possa brincar de imitações simples (como bater palmas, levantar os braços, bater os pés, tocar o nariz), brincar com instrumentos musicais, brincar com cubos de empilhar ou encaixar e manusear diferentes texturas (ex: tinta, espuma, entre outros).
    `,
    id: 7,
    levels: [
      {
        title: "Sub-habilidade A",
        id: 1,
        levels: [
          { id: 1, level: 1 },
          { id: 2, level: 2 },
          { id: 3, level: 3 },
        ],
      },
      {
        title: "Sub-habilidade B",
        id: 2,
        levels: [
          { id: 1, level: 1 },
          { id: 2, level: 2 },
          { id: 3, level: 3 },
        ],
      },
    ],
  },
  {
    title: "Motora",
    level: 2,
    position: 1,
    texto: `18 a 30 meses.
    Entre os 18 e 30 meses, espera-se que a criança seja capaz de realizar ações de motricidade ampla, como imitar 10 sequências de ações de 3 componentes diferentes quando solicitado (como bater palmas, saltar e tocar dedos dos pés, pegar uma boneca, colocá-la no berço e balançar o berço, entre outros). Também espera que a criança possa subir e descer degraus sem apoio, arremessar, receber e chutar bolas e de correr contornando obstáculos. Além disso, ela deve ser capaz de imitar de forma espontânea 5 habilidades funcionais em um ambiente natural (como comer com uma colher, colocar casaco, tirar sapatos) e capaz de imitar novas ações motoras quando um adulto demonstra um exemplo (como bater um tambor, circuitos motores simples, entre outros). Como ações de motricidade fina, espera-se que a criança seja capaz de imitar 20 ações motoras finas diferentes quando solicitado “faça isso” (como beliscar, balançar dedos, abrir e fechar as mãos, imitar uma borboleta, entre outros). Também deve ser capaz de empilhar e encaixar blocos e formas geométricas, de pintar com pincel grosso, de rasgar papel com as mãos, montar quebra cabeça simples com peças grandes e de fazer colagem. Como atividades, espera-se que a criança possa imitar gestos de músicas infantis, movimentos e sons de animais, usar massa de modelar, produzir massa de modelar a partir de ingredientes naturais, rasgar e colar papéis coloridos em figuras grandes, brincar com quebra cabeça e reconhecer e apontar as partes do corpo.`,
    id: 8,
    levels: [
      {
        title: "Sub-habilidade C",
        id: 3,
        levels: [
          { id: 1, level: 1 },
          { id: 2, level: 2 },
          { id: 3, level: 3 },
        ],
      },
      {
        title: "Sub-habilidade D",
        id: 4,
        levels: [
          { id: 1, level: 1 },
          { id: 2, level: 2 },
          { id: 3, level: 3 },
        ],
      },
    ],
  },
  {
    title: "Motora",
    level: 3,
    position: 2,
    texto: `30 a 48 meses.

    Nessa idade, espera-se que como ações de motricidade ampla, a criança seja capaz de pular para frente e para trás, utilizar tesoura para picotar ou recortar linhas retas, cobrir tracejados. Também espera que ela possa chutar bola sem perder o equilíbrio, dançar, desenhar e copiar letras, números e formas diferentes, despir-se e tirar os sapatos de forma indepentente, vestir-se com ajuda, fazer uso de talheres para alimentar-se e tomar banho com pouco auxílio. Como ações de motricidade fina, espera-se que a criança seja capaz de abrir e fechar zíperes, abrir e fechar botões grandes, fazer alinhavo. E também deve ser capaz de utilizar instrumentos como pinça para agarrar pequenos objetos ( como utilizar um pegador de alimentos para agarrar um objeto, utilizar um pregador de roupa, entre outros). Como atividades, espera-se que a criança possa brincar com circuitos motores, realizar atividades com bolas (como futebol, basquete, entre outros), cobrir desenhos tracejados, atividades com recorte, brincadeiras com o faz de conta e brincar de estátua. Também espera-se que a criança seja capaz de fazer alinhavo, brincar com pregadores de roupas e com pegadores de alimentos.
    `,
    id: 9,
    levels: [
      {
        title: "Sub-habilidade E",
        id: 5,
        levels: [
          { id: 1, level: 1 },
          { id: 2, level: 2 },
          { id: 3, level: 3 },
        ],
      },
      {
        title: "Sub-habilidade F",
        id: 6,
        levels: [
          { id: 1, level: 1 },
          { id: 2, level: 2 },
          { id: 3, level: 3 },
        ],
      },
    ],
  },
];
